import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Finagg.css";
import {
  errorCodesObject,
  popupType,
} from "../../types/types";
import {
  getDivision,
  getErrorDictionaryApi,
  getProfileByName,
} from "../../services/finaggService";
import { GenericPopUp } from "../popup/genericPopUp";
import {
  ArrowRight,
  Lock,
  AlertTriangle,
  ApiApp,
  Trash,
  CirclePlus,
  CircleMinus,
} from "tabler-icons-react";
import FinaagInputChange from "./FinaagInputChange";
import BorderHeading from "../heading/BorderHeading";

export default function Finagg() {
  const initialValuesForMetadata: any = {
    role: "",
    paymentMethod: "",
  };

  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");
  const [inputsForMetadata, setInputsForMetadata] = useState<any>(
    initialValuesForMetadata
  );
  const [inputsForProfile, setInputsForProfile] = useState<any>({});
  const [serviceUrls, setServiceUrls] = useState<any>(Object);
  const [newDivName, setNewDivName] = useState<string>("");
  const [errorCodes, setErrorCodes] = useState<errorCodesObject[]>([]);
  const [editableFields, setEditableFields] = useState<Record<string, boolean>>(
    {}
  );
  const [openContainer, setOpenContainer] = useState<string>("");
  const [divisions, setDivisions] = useState([]);
  const [newKeyName, setNewKeyName] = useState<string>("");

  const openPopup = (message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  };

  const handleChangeForMetadata = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    const updatedInputs = { ...inputsForMetadata, [name]: value };
    setInputsForMetadata(updatedInputs);
  };

  const handleOpenRightContainerKey = async () => {
    setOpenContainer("Keys");
  };

  const handleOpenRightContainerApi = () => {
    setOpenContainer("Api");
  };

  const handleOpenRightContainerError = async () => {
    setOpenContainer("ErrorCodes");
  };

  const handleChangeForProfile = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    const updatedInputs = { ...inputsForProfile, [name]: value };
    setInputsForProfile(updatedInputs);
  };

  const handleChangeForGenericObject = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: keyof errorCodesObject
  ) => {
    const { value } = e.target;
    setErrorCodes((prevErrorCodes) => {
      const updatedErrorCodes = [...prevErrorCodes];
      updatedErrorCodes[index][field] = value;
      return updatedErrorCodes;
    });
  };

  useEffect(() => {
    const method = async () => {
      const response = await getProfileByName(inputsForMetadata.paymentMethod);
      setInputsForProfile(response.data.attributes);
      setServiceUrls(response.data.attributes.ServiceURLs);
    };
    method();
    const getErrorDictionary = async () => {
      const response = await getErrorDictionaryApi(
        inputsForMetadata.paymentMethod
      );
      setErrorCodes(response.data.features);
      // console.log("errors", response);
    };
    getErrorDictionary();
    const getDivisions = async () => {
      const response = await getDivision();
      setDivisions(response.data.features);
    }
    getDivisions();
  }, [inputsForMetadata.paymentMethod]);

  // const handleOpenEditableField = (name: string) => {
  //   setEditableFields((prevEditableFields) => ({
  //     ...prevEditableFields,
  //     [name]: !prevEditableFields[name],
  //   }));
  // };

  const handleAddNewDiv = (newDivName: string) => {
    if (newDivName !== "") {
      setServiceUrls((prevServiceUrls: any) => ({
        ...prevServiceUrls,
        [newDivName]: {},
      }));

      setEditableFields((prevEditableFields: any) => ({
        ...prevEditableFields,
        [newDivName]: {},
      }));

      setNewDivName("");
    }
  };

  const handleDeleteDiv = (name: string) => {
    const updatedServiceUrls = { ...serviceUrls };
    delete updatedServiceUrls[name];

    const updatedEditableFields = { ...editableFields };
    delete updatedEditableFields[name];

    setServiceUrls(updatedServiceUrls);
    setEditableFields(updatedEditableFields);
  };

  const handleAddRow = () => {
    setErrorCodes((prevErrorCodes) => [
      ...prevErrorCodes,
      { key2: "", key3: "", key5: "", key4:"", custom: true },
    ]);
  };

  const handleDeleteRow = (index: number) => {
    setErrorCodes((prevErrorCodes) => {
      const updatedErrorCodes = [...prevErrorCodes];
      updatedErrorCodes.splice(index, 1);
      return updatedErrorCodes;
    });
  };

  const handleAddTextField = (newKeyName : string) => {
    setInputsForProfile((prevState:any) => {
      const newName = newKeyName;
      if (newName) {
        return {
          ...prevState,
          [newName]: "",
        };
      }
      return prevState;
    });
    setNewKeyName("");
  };

  const handleDeleteTextField = (key:any) => {
    setInputsForProfile((prevState:any) => {
      const { [key]: value, ...updatedInputs } = prevState;
      return updatedInputs;
    });
  };



  const handleSubmitProfile = async () => {
    let array = [];
    array.push(inputsForMetadata);
    let requestBodyForMetadata = {
      domainName: "clientconfig",
      domainType: "finagg_generic_configurations",
      domainValues: array,
    };
    
    inputsForProfile.ServiceUrls = serviceUrls;
    delete inputsForProfile.ServiceURLs;
    let requestBodyForProfile = {
      name: inputsForMetadata.paymentMethod,
      type: "integration",
      attributes: inputsForProfile,
    };
    // console.log("requestBodyForProfile", requestBodyForProfile);
    // console.log("requestBodyForMetadata", requestBodyForMetadata);
    // const responseProfile = await updateProfile(bodyProfile);
    // const response = await updateMetaData(requestBodyForMetadata);
  };

  const handleSubmitGenericObject = async () => {
    errorCodes.forEach((error: any) => {
      if(error.custom) delete error.custom
    })
    // console.log(errorCodes);
    // console.log(requestBodyForGenericObject);
  };
console.log(divisions);
  return (
    <div className="finagg-container">
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />

      <BorderHeading>One click Integration</BorderHeading>

      <div className="main-container-config">
        <div className="left-container">
          <FormControl className="role-options">
            <InputLabel id="demo-simple-select-label">Select role</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={inputsForMetadata.role}
              label="Select role"
              onChange={handleChangeForMetadata}
              name="role"
            >
              {divisions.map((item:any)=>(
                <MenuItem value={item.divisionName}>{item.divisionName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className="paymentMethodOptions">
            <InputLabel id="demo-simple-select-label">
              Select payment method
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={inputsForMetadata.paymentMethod}
              label="Select payment method"
              onChange={handleChangeForMetadata}
              name="paymentMethod"
            >
              <MenuItem value={"FINAGG"}>Finagg</MenuItem>
              <MenuItem value={"AXIS"}>Axis</MenuItem>
              <MenuItem value={"SBI"}>SBI</MenuItem>
            </Select>
          </FormControl>
          <div className="left-container-config">
            <Lock size={30} strokeWidth={1} color={"black"} />
            Encryption/Decryption Algorithm
            <ArrowRight
              style={{ marginLeft: "auto" }}
              onClick={handleOpenRightContainerKey}
            />
          </div>
          <div className="left-container-config">
            <ApiApp size={30} strokeWidth={1} color={"black"} />
            API
            <ArrowRight
              style={{ marginLeft: "auto" }}
              onClick={handleOpenRightContainerApi}
            />
          </div>
          <div className="left-container-config">
            <AlertTriangle size={30} strokeWidth={1} color={"black"} />
            Error and display
            <ArrowRight
              style={{ marginLeft: "auto" }}
              onClick={handleOpenRightContainerError}
            />
          </div>
        </div>

        <Box className="right-container">
          {openContainer === "Api" && (
            <div className="right-container-api">
              {Object.keys(serviceUrls).map((name, index) => (
                <fieldset
                  className="api-container"
                  key={index}
                  style={{
                    border: "1px solid black",
                    margin: "10px",
                    padding: "10px",
                  }}
                >
                  <legend className="api-name">{name}</legend>

                  <FinaagInputChange
                    serviceName={name}
                    serviceUrls={serviceUrls}
                    setServiceUrls={setServiceUrls}
                    // onClose={() => handleOpenEditableField(name)}
                  />
                  <div className="icons">
                    <Trash
                      size={25}
                      strokeWidth={1}
                      color={"black"}
                      onClick={() => handleDeleteDiv(name)}
                    />
                  </div>
                </fieldset>
              ))}
              {/* <button onClick={handleAddNewDiv}>Add New API</button> */}

              <div className="addNewDiv">
                <div>
                  <label htmlFor="newDivName">Api name: </label>
                  <input
                    type="text"
                    value={newDivName}
                    onChange={(e) => setNewDivName(e.target.value)}
                  />
                </div>
                <CirclePlus
                  size={35}
                  strokeWidth={1}
                  color={"#23c6b0"}
                  onClick={() => handleAddNewDiv(newDivName)}
                />
              </div>
              <div className="submit-button-bank-parent">
                <Button
                  className="submit-button-bank"
                  variant="contained"
                  onClick={handleSubmitProfile}
                >
                  Submit
                </Button>
              </div>
            </div>
          )}

          {openContainer === "Keys" && (
            <div className="keys">
              {Object.entries(inputsForProfile).map(
                ([key, value]) =>
                  key !== "ServiceURLs" && (
                    <div style = {{display: "flex", alignItems: "center", gap: "10px"}} key={key}>
                    <TextField
                      className="keys-input"
                      id="outlined-basic"
                      label={key}
                      variant="outlined"
                      value={value}
                      onChange={handleChangeForProfile}
                      name={key}
                    />
                    <CircleMinus
                    size={20}
                    strokeWidth={1}
                    color={"red"}
                    onClick={() => handleDeleteTextField(key)}
                  />
                  </div>
                  )
              )}
              <div style = {{display: "flex", alignItems: "center", gap: "10px"}}>
              <input className = 'textFieldNewKeyInput'
                  placeholder="Enter new key"
                  type="text"
                  value={newKeyName}
                  onChange={(e) => setNewKeyName(e.target.value)}
                />
              <CirclePlus
                  size={48}
                  strokeWidth={2}
                  color={"#23c6b0"}
                  onClick={()=>handleAddTextField(newKeyName)}
                />
                </div>
            </div>
          )}

          {openContainer === "ErrorCodes" && (
            <div className="errorCodes">
              <table>
                <thead style={{ height: "6vh" }}>
                  <tr className="errorHeadings">
                    <th style={{ width: "20%" }}>Error Code</th>
                    <th style={{ width: "40%" }}>Error description</th>
                    <th style={{ width: "40%" }}>Display name</th>
                    <th style={{ width: "20%" }}>Status</th>
                    <th style={{ width: "5%" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(errorCodes).map((item: any, index: any) => (
                    <tr key={index}>
                      <td className="errorCodeNumbers">
                        <input className="errorCodeInput"
                          readOnly={!item[1].custom}
                          placeholder="Error Code"
                          type="text"
                          value={item[1].key2}
                          onChange={(e) =>
                            handleChangeForGenericObject(e, index, "key2")
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="descriptionInput"
                          readOnly={!item[1].custom}
                          placeholder="Error Description"
                          type="text"
                          value={item[1].key3}
                          onChange={(e) =>
                            handleChangeForGenericObject(e, index, "key3")
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="displayInput"
                          contentEditable={true}
                          placeholder="Display name"
                          type="text"
                          value={item[1].key5}
                          onChange={(e) =>
                            handleChangeForGenericObject(e, index, "key5")
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="displayStatus"
                          contentEditable={true}
                          placeholder="Display Status"
                          type="text"
                          value={item[1].key4}
                          onChange={(e) =>
                            handleChangeForGenericObject(e, index, "key4")
                          }
                        />
                      </td>
                      <td>
                      <CircleMinus
                    size={20}
                    strokeWidth={1}
                    color={"red"}
                    onClick={() => handleDeleteRow(index)}
                  />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div>
              <CirclePlus
                  size={48}
                  strokeWidth={2}
                  color={"#23c6b0"}
                  onClick={handleAddRow}
                />
                </div>
              <div className="submit-button-bank-parent">
                <Button
                  className="submit-button-bank"
                  variant="contained"
                  onClick={handleSubmitGenericObject}
                >
                  Submit
                </Button>
              </div>
            </div>
          )}
        </Box>
      </div>
    </div>
  );
}
